<template>
<div class="TTL-el-form-search-regular">
    <el-form inline="true">
        <el-form-item>
            <wcselect :option="{placeholder:'处理状态',ischange:true,width:'170px',clearable:true,filterable:true}" 
                :value="param.is_handle"
                :list="handlelist"
                @finish="(val)=> {
                    param.is_handle=val.value;
                    param.ischange=true;
                    GetList();
                }"
            />
        </el-form-item>
        <el-form-item>
        <wcinput :option="{placeholder:'举报原因',clearable:true,ischange:true,width:'250px',isinput:true,iskeydown:true,clearable:true}" 
            :value="param.key"
            @finish="(val)=> {
                if(val.type=='input') {param.key=val.value;param.ischange=true}
                if(val.type=='change') {param.key=val.value;param.ischange=true}
                if(val.type=='keydown') GetList();
            }"
        />
        </el-form-item>
        <el-form-item>
        <wcbutton :option="{title:'搜索'}" @finish="GetList"/>
        </el-form-item>
    </el-form>
</div>


<div class="TTL-table top20" :ref="objloading">
    <el-table :data="list" stripe="true" empty-text="" >
        <template v-slot:empty><el-empty description="暂无数据" /></template>
        <el-table-column label="商品图" align="center">
            <template #default="scope">
                <wcimage :option="{size:'middle'}" :value="scope.row.goodsthumb" />
            </template>
        </el-table-column>
        <el-table-column label="商品名称" align="center">
            <template #default="scope">
                <div class="TTL-goodsname" 
                @click="$parent.JUMPVIEW({name:'EsFrozenDetail',param:{id:scope.row.id}})"
                >{{scope.row.goodsname}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="reportmembername" label="举报人" align="center"/>
        <el-table-column prop="reason" label="举报原因" align="center"/>
        <el-table-column prop="inputtime" label="举报时间" align="center"/>
        <el-table-column label="状态" align="center">
            <template #default="scope">
                <span v-if="scope.row.is_handle==0">/</span>
                <span v-if="scope.row.is_handle==1">冻结商品</span>
                <span v-if="scope.row.is_handle==2">冻结会员</span>
                <span v-if="scope.row.is_handle==3">忽略</span>
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="190">
            <template #default="scope">
            <div class="TTL-btn-info">
                <wcbutton :option="{title:'忽略',type:'del'}" @finish="ignoreFrozen(scope.row.id)" v-if="scope.row.is_handle==0" />
                <wcbutton :option="{title:'冻结商品',type:'del'}" @finish="FrozenGoods(scope.row.id)" class="left10" v-if="scope.row.is_handle==0" />
                <wcbutton 
                    :option="{title:'冻结会员',type:'del'}" 
                    @finish="$parent.JUMPVIEW({name:'EsFrozenMember',param:{id:scope.row.memberid,pid:scope.row.id,name:scope.row.membername,phone:scope.row.memberphone,thumb:scope.row.memberthumb,rollbackname:'Frozen'}});" 
                    class="left10" 
                    v-if="scope.row.is_handle==0" 
                />
            </div>
            </template>
        </el-table-column>
    </el-table>
</div>


<div class="TTL-page-box top20">
    <div class="TTL-page-box-in">
        <div class="TTL-page TTL-page-right">
            <wcpage :row="param.rows" :p="param.p" :rollpage="param.rollpage"
                @finish="(val)=> {
                    param.p=val.p;
                    param.rollpage=val.rollpage;
                    GetList();
                }"
            />
        </div>
    </div>
</div>



</template>

<script>
import INTERFACE_MODEL_GOODS from '@/Interface/Es/Goods/Goods';
export default {

    components:{},
    data() {
        return {
            objloading:'frozen',
            param: {
                key:'',
                memberid:'',
                report_memberid:'',
                goodsid:'',
                is_handle:1,
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },
            list:[],
            handlelist:[
                {id:1,name:'未处理'},
                {id:2,name:'已处理'}
            ],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除数据'},
                {id:2,name:'批量修改数据'},
            ],

        }
    },

    mounted() {

        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetList();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                this.GetList();
            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }
        },


        /** 列表数据搜索 **/
        GetList() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            var obj=this.$refs[this.objloading];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_GOODS.GET_FROZEN_LOG(this.param).then((res) => {
                 this.$loading.closeloading(obj);
                 if(res.status > 0) return false;
                 this.param.rows=res.data.count;
                 this.list=res.data.list;
            });
        },


        /** 忽略举报记录处理 **/
        ignoreFrozen(id) {
            INTERFACE_MODEL_GOODS.FROZEN_IGNORE({id:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetList();
            });
        },


        /** 冻结商品 **/
        FrozenGoods(id) {
            INTERFACE_MODEL_GOODS.FROZEN_GOODS({id:id}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetList();
            });
        },


    },
}
</script>
<style scoped>
::v-deep(.TTL-switch .el-switch__label *) {font-size:13px;color:#666666;letter-spacing: 1px;}
.TTL-btn-info {display:inline-flex;}
.ttl-frozen {display: inline-flex;justify-content: center;align-items: center;width:100% !important;}
.ttl-frozen .el-image{display: inline-block;width:25px;height:25px;margin-right:5px;}
.ttl-finiss {display:inline-block;width:100%;text-align:center;font-size:13px;color:#666666;letter-spacing:1px;color:#666eeb}
.answer-name {font-style: normal;color:#666eeb;}
.goods-commont {display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;text-overflow: ellipsis;width:100%;}
.goods-commont-box {display:inline-flex;width:200px;padding:15px 0;font-size:0;}
.goods-commont-box .el-image {width:50px;height:50px;border-radius: 50%;display: inline-block;}
.goods-commont-content {display: inline-block;width:calc(100% - 50px - 15px);min-height: 50px;font-size:0;}
.goods-commont-name {display: inline-flex;align-items: center;width:100%;font-size:12px;line-height:18px;position:relative;}
.goods-commont-time {position:absolute;right:0;font-size:12px;}
.goods-commont-name i {font-style:normal;color:#999999}
.content {display: inline-block;margin-top:0;}
.membername {font-size:13px;color:#666eeb;}
.TTL-goodsname {color:#666eeb;cursor: pointer;}
</style>